/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Meta_DescriptionInputs */

const es_privacy_policy_meta_description = /** @type {(inputs: Privacy_Policy_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conoce como Nexata recopila, usa y protege tu informacion personal. No vendemos tus datos a terceros.`)
};

const en_privacy_policy_meta_description = /** @type {(inputs: Privacy_Policy_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how Nexata collects, uses, and protects your personal information. We never sell your data to third parties.`)
};

/**
* | output |
* | --- |
* | "Learn how Nexata collects, uses, and protects your personal information. We never sell your data to third parties." |
*
* @param {Privacy_Policy_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_meta_description = /** @type {((inputs?: Privacy_Policy_Meta_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Meta_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_meta_description(inputs)
	return en_privacy_policy_meta_description(inputs)
});
export { privacy_policy_meta_description as "privacy_policy.meta.description" }